export const PartialStockModalType = {
   OrderStockModal : 1,
   TransferStockModal :2
};